module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av733-1b4bbb3bf0adedee50171968c84ec14e.jpg";